import { render, staticRenderFns } from "./compare2.vue?vue&type=template&id=5b4ead5e&scoped=true"
import script from "./compare2.vue?vue&type=script&lang=js"
export * from "./compare2.vue?vue&type=script&lang=js"
import style0 from "./compare2.vue?vue&type=style&index=0&id=5b4ead5e&prod&lang=css"
import style1 from "./compare2.vue?vue&type=style&index=1&id=5b4ead5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4ead5e",
  null
  
)

export default component.exports